module.exports = __webpack_public_path__ + "static/down-arrow-4ab9eaee25c5176ab3ff47280875ab74.png";